// Check active shopper eligibility on a user row or unwrapped profile.
const isActiveShopper = user => !!user?.isShopper && !user.Brand_id && !user.isArchived && !user.isBanned;

module.exports = { isActiveShopper };
